/**
 * @Description: 使用素材或者线索选择稿件类型的组件
 * @author zhaijiayu
 * @date 2021/9/6
*/
<template>
  <el-dialog
    :visible="show"
    title="选择稿件类型"
    class="script-type-selector"
    :show-close="false"
  >
    <div class="content">
      <el-radio-group v-model="type">
        <el-radio
          :label="key"
          v-for="(value, key) in manuscriptType"
          :key="value + key"
          >{{ value }}</el-radio
        >
      </el-radio-group>
      <div slot="footer" style="margin: 50px 0 0; text-align: right">
        <el-button @click="cancelSelect && cancelSelect()">取 消</el-button>
        <el-button type="primary" @click="finishSelect && finishSelect(type)"
          >确 定</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { MANUSCRIPT_TYPE } from "../constants/manuscript";

export default {
  name: "script-type-selector",
  computed: {
    manuscriptType: function () {
      // 素材可选择的写稿类型有限制，如下：
      // 文章素材 - 【'文稿'】
      // 图片素材 - 【'文稿','图集'】
      // 视频素材 - 【'文稿','视频'】
      let supportType = ["1", "2", "3"];
      switch (this.materialType) {
        // 文稿素材
        case "1":
          //supportType = ["1"];
          supportType = [];
          break;
        // 图片素材
        case "2":
          supportType = ["1", "3"];
          break;
        // 视频素材
        case "3":
          supportType = ["1", "2"];
          break;
        default:
          break;
      }
      let typeList = {};
      for (let i in MANUSCRIPT_TYPE) {
        if (supportType.includes(i)) {
          typeList[i] = MANUSCRIPT_TYPE[i];
        }
      }
      return typeList;
    },
  },
  props: {
    show: Boolean,
    materialType: String,
    finishSelect: Function,
    cancelSelect: Function,
  },
  data: function () {
    return {
      type: "1",
    };
  },
};
</script>
<style scoped lang="scss">
.script-type-selector {
  text-align: left;
  /deep/.el-button {
    padding: 12px 20px !important;
  }
}
</style>
